import React, { useEffect, useContext } from 'react';
import { useIntl } from 'react-intl';
import { Grid } from '@material-ui/core';
import { Panel, Container } from '../../../../Components';
import { HelpPanel } from './HelpPanel';
import { ModuleContext } from '../../../../Context/ModuleContext/ModuleContext';

export const Help = () => {
  const { setHeader } = useContext(ModuleContext);
  const { formatMessage } = useIntl();

  useEffect(() => {
    setHeader(formatMessage({ id: 'law-portal.help', defaultMessage: 'Settings' }));
  }, [setHeader, formatMessage]);

  return (
    <Container>
      <Grid container spacing={4} direction="column" justifyContent="space-evenly">
        <Grid item>
          <Panel titleKey="law-portal.settings.help" accordion defaultExpanded>
            <HelpPanel />
          </Panel>
        </Grid>
      </Grid>
    </Container>
  );
};
